import "../scss/style.scss";
import "./home.js";
import "./products.js";
import "./recruit.js";
import objectFitImages from 'object-fit-images';
import 'jquery-match-height';
import 'lity';
import slick from 'slick-carousel';

jQuery(function ($) {

  // smooth scroll
  var headerHeight = $('.header').outerHeight();
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function() {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }
  $('a[href^="#"]').click(function() {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
    return false;
  });

  // SP menu
  $(function(){
    $('.js-nav-btn').on('click',function(){
      $(".js-nav").toggleClass('is-open');
      $(this).toggleClass('is-close');
    });
    $('.js-nav a[href^="#"], .js-nav-overlay').on('click',function(){
      $(".js-nav").removeClass('is-open');
      $('.js-nav-btn').removeClass('is-close');
    });
  });

  // ドロップダウン
  $(function () {
    var dropdown = $('.nav-list__item.dropdown');
    var dropdownItem = $('.nav-list__item.dropdown .dropdown_item');
    var toggleClickA = $('.nav-list__item.dropdown .top');
    if (matchMedia('(max-width: 767px)').matches) {
      dropdown.removeClass('close');
      dropdownItem.css('display', 'block');
      toggleClickA.on('click', function () {
        dropdown.toggleClass('close');
        dropdownItem.stop().slideToggle();
      });
    } else {
      dropdownItem.removeClass('open');
      dropdown.hover(function (e) {
        $(this).find(dropdownItem).addClass('open');
      }, function () {
        $(this).find(dropdownItem).removeClass('open');
      });
    }
  });

  // pagetop
  $(function(){
    $(window).scroll(function () {
      if($(this).scrollTop() >= 300) {
        $('.js-pagetop').fadeIn();
      } else {
        $('.js-pagetop').fadeOut();
      }
    });
  });

  $(function () {
    objectFitImages('.js-objectfit-img');
  });

  // tab
  $(function() {
    $('.js-tab-btn').click(function() {
      var index = $(this).parent().children('.js-tab-btn').index(this);
      $(this).parent().children('.js-tab-btn').removeClass('is-active');
      $(this).addClass('is-active');
      $(this).parents('.js-tab-set').find('.js-tab-content').removeClass('is-show').eq(index).addClass('is-show');
    });
  });

  //tab切り替え
  $(function () {
    $('.js-tab li').click(function () {
      var index = $('.js-tab li').index(this);
      $('.js-tab li').removeClass('on');
      $(this).addClass('on');
      $('.js-area .js-area-box').removeClass('show').eq(index).addClass('show');
    });
  });

  // プルダウン
  $('.js-pullDown').on('click', function (event) {
    event.preventDefault();
    $(this).toggleClass('close');
    $(this).next().slideToggle();
  });

  $(function(){
    $('.p-company__tagList >li').each(function(index,element){
      var w = $(element).width()
      $('.p-company__tagList').append('<li style="height:0; width:'+ w +'px; margin:0;"></li>')
    })
  })


});